import React, { useState } from "react";
import styled from "styled-components";
import { FiDownload } from "react-icons/fi";
import { FaCheck } from "react-icons/fa";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import BookingModal from "./Modals/BookingModal";
import BookingSuccessModal from "./Modals/BookingSuccessModal";

const Container = styled.div`
  width: 80%;
  margin: 0 auto;
  padding: 20px;
  /* background-color: #f8f9fa; */
  font-weight: 400;
  margin-top: 6.25rem;
  font-family: Montserrat;
`;
const PageLayout = styled.div`
  display: flex;
  gap: 25px;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const LeftColumn = styled.div`
  flex: 0 0 70%;
  @media (max-width: 768px) {
    flex: 1;
  }
`;

const RightColumn = styled.div`
  flex: 0 0 30%;
  @media (max-width: 768px) {
    flex: 1;
  }
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
`;

const Tag = styled.span`
  background: #f0f4ff;
  color: #4a6cf7;
  padding: 5px 12px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
`;

const SessionTitle = styled.h1`
  font-size: 28px;
  margin: 0;
  font-weight: 600;
  color: #2d3748;
`;

const Section = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 25px;
  margin-bottom: 25px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  border: 1px solid #edf2f7;
`;

const SectionTitle = styled.h2`
  font-size: 18px;
  margin-bottom: 15px;
  color: #2d3748;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Description = styled.p`
  line-height: 1.6;
  color: #4a5568;
  margin: 0;
`;

const BulletList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const BulletItem = styled.li`
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
  gap: 10px;
`;

const CheckIcon = styled(FaCheck)`
  color: #38a169;
  flex-shrink: 0;
  margin-top: 4px;
`;

const Requirements = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  background: #f8fafc;
  border-radius: 10px;
  border: 1px dashed #cbd5e0;
`;

const DownloadButton = styled.button`
  background: none;
  border: none;
  color: #e53e3e;
  cursor: pointer;
  font-size: 16px;
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 5px 10px;
  border-radius: 6px;
  transition: all 0.2s;

  &:hover {
    background: #fee2e2;
  }
`;

const TimeSlotsContainer = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-top: 15px;
`;

const TimeSlot = styled.button`
  background: #e6f7ff;
  border: 1px solid #b3e0ff;
  padding: 8px 15px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  color: #1a73e8;
  font-weight: 500;
  transition: all 0.2s;

  &:hover {
    background: #b3e0ff;
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }
`;

const ProfileCard = styled(Section)`
  position: sticky;
  top: 20px;
  @media (max-width: 768px) {
    position: static;
  }
`;

const ProfileHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 20px;
`;

const ProfilePic = styled.img`
  width: 100px;
  height: 100px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid #f0f4ff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
`;

const ProfileInfo = styled.div`
  flex: 1;
`;

const ProfileName = styled.h2`
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: #2d3748;
`;

const ProfileTitle = styled.p`
  margin: 5px 0 0;
  color: #4a5568;
  font-size: 16px;
  font-weight: 500;
`;

const Languages = styled.div`
  display: flex;
  gap: 10px;
  margin: 15px 0;
  flex-wrap: wrap;
`;

const LanguageTag = styled(Tag)`
  background: #f0f4ff;
  color: #4a6cf7;
`;

const Specializations = styled.div`
  margin: 15px 0;
`;

const SpecializationTags = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
`;

const SpecializationTag = styled.span`
  background: #f8fafc;
  color: #2d3748;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  border: 1px solid #edf2f7;
`;

const Stats = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
  padding: 15px 0;
  border-top: 1px solid #edf2f7;
  border-bottom: 1px solid #edf2f7;
`;

const StatItem = styled.div`
  text-align: center;
  flex: 1;
`;

const StatValue = styled.div`
  font-size: 22px;
  font-weight: 700;
  color: #2d3748;
`;

const StatLabel = styled.div`
  font-size: 14px;
  color: #718096;
  margin-top: 4px;
`;

const BookButton = styled.button`
  width: 100%;
  background: #e53e3e;
  color: white;
  border: none;
  padding: 16px;
  border-radius: 10px;
  font-size: 16px;
  cursor: pointer;
  font-weight: 600;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(229, 62, 62, 0.2);

  &:hover {
    background: #c53030;
    transform: translateY(-2px);
    box-shadow: 0 6px 8px rgba(229, 62, 62, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
`;

const AvailabilityHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
`;

const AvailabilityLabel = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: #4a5568;
`;

const AvailabilityDate = styled.span`
  font-size: 14px;
  color: #718096;
`;

const SessionProfile = ({ data, onBooking }) => {
  // Extract session and creator data
  const {
    name,
    category,
    objective,
    description,
    creator,
    total_bookings,
    average_rating,
    attachments,
    duration,
    setting_config,
  } = data;

  // Generate unique specializations from creator's expertise
  const uniqueExpertise = Array.from(
    new Set(creator?.expertise?.map((e) => e.name) || []),
  );

  // Handle attachment download
  const handleDownloadAttachment = () => {
    if (attachments) {
      // Open attachment in new tab to download
      window.open(attachments, "_blank");
    }
  };

  return (
    <Container>
      <PageLayout>
        <LeftColumn>
          <Header>
            <Tag>{category || "Meditation"}</Tag>
            <Tag>{duration ? `${duration} min` : "60 min"}</Tag>
          </Header>

          <Section>
            <SessionTitle>{name}</SessionTitle>
            {description && (
              <>
                <SectionTitle>Description</SectionTitle>
                <Description>{description}</Description>
              </>
            )}
            {objective && (
              <>
                <SectionTitle>Objective</SectionTitle>
                <Description>{objective}</Description>
              </>
            )}
          </Section>

          {attachments && (
            <Section>
              <SectionTitle>Session Materials</SectionTitle>
              <Requirements>
                <span>Preparatory guide and resources</span>
                <DownloadButton onClick={handleDownloadAttachment}>
                  <FiDownload size={18} /> Download Attachment
                </DownloadButton>
              </Requirements>
            </Section>
          )}
        </LeftColumn>

        <RightColumn>
          <ProfileCard>
            <ProfileHeader>
              <ProfilePic
                src={creator?.profile_pic?.trim()}
                alt={creator?.name}
              />
              <ProfileInfo>
                <ProfileName>{creator?.name}</ProfileName>
                <ProfileTitle>{creator?.designation}</ProfileTitle>
              </ProfileInfo>
            </ProfileHeader>

            {creator?.language_known && (
              <Languages>
                {creator.language_known.split(",").map((lang, index) => (
                  <LanguageTag key={index}>{lang.trim()}</LanguageTag>
                ))}
              </Languages>
            )}

            {setting_config && (
              <Languages>
                {setting_config.level && (
                  <LanguageTag>{setting_config.level}</LanguageTag>
                )}
                {setting_config.language && (
                  <LanguageTag>{setting_config.language}</LanguageTag>
                )}
              </Languages>
            )}

            {uniqueExpertise.length > 0 && (
              <Specializations>
                <SectionTitle>Specializations</SectionTitle>
                <SpecializationTags>
                  {uniqueExpertise.map((expertise, index) => (
                    <SpecializationTag key={index}>
                      {expertise}
                    </SpecializationTag>
                  ))}
                </SpecializationTags>
              </Specializations>
            )}

            <Stats>
              <StatItem>
                <StatValue>{total_bookings || 0}+</StatValue>
                <StatLabel>Sessions</StatLabel>
              </StatItem>
              <StatItem>
                <StatValue>
                  {average_rating ? average_rating.toFixed(1) : "-"}
                </StatValue>
                <StatLabel>Rating</StatLabel>
              </StatItem>
            </Stats>

            <BookButton onClick={onBooking}>Book Session Now</BookButton>
          </ProfileCard>
        </RightColumn>
      </PageLayout>
    </Container>
  );
};

// Usage example
export default function SessionDetailsPage() {
  const location = useLocation();

  const [isLoading, setIsLoading] = useState(false);

  const [openBookingModal, setOpenBookingModal] = useState(false);
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [successData, setSuccessData] = useState(null);

  const data = location.state.session;

  console.log("sessionDetailsPage", {
    openBookingModal,
    openSuccessModal,
  });
  return (
    <>
      {openBookingModal && (
        <BookingModal
          session={data}
          onClose={(result) => {
            setOpenBookingModal(false);
            if (result?.success) {
              setSuccessData(result);
              setOpenSuccessModal(true);
            }
          }}
        />
      )}
      {openSuccessModal && (
        <BookingSuccessModal
          bookingData={successData}
          onClose={() => {
            setOpenSuccessModal(false);
            setSuccessData(null);
          }}
        />
      )}
      <SessionProfile data={data} onBooking={() => setOpenBookingModal(true)} />
    </>
  );
}

const testData = {
  id: 17,
  creator_name: "Prof. Charles Xavier",
  average_rating: 4,
  total_bookings: 1,
  SessionRating: [],
  creator: {
    id: 389,
    experience: [
      {
        id: "9bf18cd9-f169-4cf6-94f1-358bf80a7775",
        description: "Genetics Researcher",
        upload_img:
          "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/Experience_images/9bf18cd9-f169-4cf6-94f1-358bf80a7775-1670351626_13-kartink.jpg",
        title: "Genetics Researcher",
        start_date: "2001-07-12",
        end_date: "2010-01-05",
        employment_type: "Full time Researcher at Oxford University",
        company: "Oxford University",
        timestamp: "2023-12-07T11:43:47.220000Z",
        u_timestamp: "2023-12-12T17:16:18.746895Z",
        profile_id: 389,
      },
      {
        id: "d248dc04-1b10-4dc0-8d3b-fde57d46ad24",
        description: "Served as a tenure professor and researcher at Harvard.",
        upload_img:
          "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/Experience_images/d248dc04-1b10-4dc0-8d3b-fde57d46ad24-hardvard-1.jpg",
        title: "Professor of Mutant Biology",
        start_date: "2010-03-03",
        end_date: "2020-03-20",
        employment_type: "Tenure Professor and Researcher",
        company: "Harvard University",
        timestamp: "2023-12-07T11:33:33.887775Z",
        u_timestamp: "2023-12-07T11:33:33.887818Z",
        profile_id: 389,
      },
    ],
    education: [
      {
        id: "071fe808-e63c-4a95-8da4-c6afca73af3b",
        description:
          "Advanced clinical training with focus on evidence-based therapies",
        participations: "",
        upload_img: null,
        school: "Harvard University",
        start_date: "2013-09-01",
        end_date: "2015-06-01",
        field_of_study: "Clinical Psychology",
        degree: "Master of Arts",
        grade: "",
        timestamp: "2026-01-08T11:20:37.744359Z",
        u_timestamp: "2026-01-08T11:20:37.744387Z",
        profile_id: 389,
      },
      {
        id: "32a634ec-aa09-4f9f-9949-12c2864850e8",
        description: "",
        participations: "",
        upload_img:
          "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/Education_images/32a634ec-aa09-4f9f-9949-12c2864850e8-1636px-Oxford-Universi.png",
        school: "Oxford",
        start_date: "1965-02-16",
        end_date: "1972-05-09",
        field_of_study: "Genetics",
        degree: "PhD in Genetics",
        grade: "A",
        timestamp: "2023-12-22T05:50:11.629414Z",
        u_timestamp: "2023-12-22T05:50:11.629456Z",
        profile_id: 389,
      },
      {
        id: "39cd4e8b-0236-4d33-8b6a-25c032c7b69d",
        description: "",
        participations: "",
        upload_img: null,
        school: "University of California, Berkeley",
        start_date: "2009-09-01",
        end_date: "2013-06-01",
        field_of_study: "Psychology",
        degree: "Bachelor of Arts",
        grade: "",
        timestamp: "2026-01-08T11:20:09.432744Z",
        u_timestamp: "2026-01-08T11:20:09.432776Z",
        profile_id: 389,
      },
      {
        id: "3ea01071-7d68-4adb-bb1b-b321d64c9810",
        description: "",
        participations: "",
        upload_img: null,
        school: "University of California, Berkeley",
        start_date: "2009-09-01",
        end_date: "2013-06-01",
        field_of_study: "Psychology",
        degree: "Bachelor of Arts",
        grade: "",
        timestamp: "2026-01-08T11:20:37.755114Z",
        u_timestamp: "2026-01-08T11:20:37.755142Z",
        profile_id: 389,
      },
      {
        id: "48754bd1-8197-44b9-bdea-7ea23caf4262",
        description: "",
        participations: "",
        upload_img: null,
        school: "University of California, Berkeley",
        start_date: "2009-09-01",
        end_date: "2013-06-01",
        field_of_study: "Psychology",
        degree: "Bachelor of Arts",
        grade: "",
        timestamp: "2026-01-08T11:21:40.331074Z",
        u_timestamp: "2026-01-08T11:21:40.331110Z",
        profile_id: 389,
      },
      {
        id: "978cee71-c88a-48f1-a5ce-596005e52426",
        description:
          "Advanced clinical training with focus on evidence-based therapies",
        participations: "",
        upload_img: null,
        school: "Harvard University",
        start_date: "2013-09-01",
        end_date: "2015-06-01",
        field_of_study: "Clinical Psychology",
        degree: "Master of Arts",
        grade: "",
        timestamp: "2026-01-08T11:20:09.421596Z",
        u_timestamp: "2026-01-08T11:20:09.421626Z",
        profile_id: 389,
      },
      {
        id: "c266e764-0898-43e4-86ec-b70b0ddddc97",
        description:
          "Advanced clinical training with focus on evidence-based therapies",
        participations: "",
        upload_img: null,
        school: "Harvard University",
        start_date: "2013-09-01",
        end_date: "2015-06-01",
        field_of_study: "Clinical Psychology",
        degree: "Master of Arts",
        grade: "",
        timestamp: "2026-01-08T11:21:40.320763Z",
        u_timestamp: "2026-01-08T11:21:40.320791Z",
        profile_id: 389,
      },
    ],
    certification: [
      {
        id: "4a1c9610-b5b4-4658-8806-308a07159e24",
        description: "State-licensed to practice clinical psychology",
        upload_img: null,
        name: "Licensed Clinical Psychologist",
        issuer: "American Psychological Association",
        issue_date: "2016-07-01",
        expiry_date: "2026-07-01",
        certification_id: "",
        certification_url: "https://www.apa.org",
        timestamp: "2026-01-08T11:21:40.361441Z",
        u_timestamp: "2026-01-08T11:21:40.361472Z",
        profile_id: 389,
      },
      {
        id: "920b27d8-1094-4f31-ac3f-0dfbcf8b099e",
        description: "State-licensed to practice clinical psychology",
        upload_img: null,
        name: "Licensed Clinical Psychologist",
        issuer: "American Psychological Association",
        issue_date: "2016-07-01",
        expiry_date: "2026-07-01",
        certification_id: "",
        certification_url: "https://www.apa.org",
        timestamp: "2026-01-08T11:20:37.822623Z",
        u_timestamp: "2026-01-08T11:20:37.822650Z",
        profile_id: 389,
      },
      {
        id: "aba70f93-b10c-4c33-8ca9-5e4d72c59714",
        description:
          "Cybersecurity analyst responsible for monitoring and protecting networks, devices, people, and data.",
        upload_img:
          "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/Certifications_images/aba70f93-b10c-4c33-8ca9-5e4d72c59714-1vnlz431qvB1jspmJ.png",
        name: "Network Security",
        issuer: "CCNA",
        issue_date: "2024-03-26",
        expiry_date: "2024-06-27",
        certification_id: "CCN3434",
        certification_url: "https://grow.google/certificates/cybersecurity/",
        timestamp: "2024-03-26T07:46:05.493509Z",
        u_timestamp: "2024-03-26T07:46:05.493552Z",
        profile_id: 389,
      },
    ],
    achievement: [
      {
        id: "03ebd0bd-7261-4732-9564-c2aaa577dca1",
        description:
          "Recognized for outstanding patient outcomes and community impact",
        upload_img: null,
        name: "Excellence in Mental Health Award",
        issuer: "National Alliance on Mental Illness",
        issue_date: "2023-05-15",
        timestamp: "2026-01-08T11:21:40.372194Z",
        u_timestamp: "2026-01-08T11:21:40.372225Z",
        profile_id: 389,
      },
      {
        id: "2614bff1-32aa-47eb-8e4a-0025f18444de",
        description: "Awarded for pro-bono counseling services during pandemic",
        upload_img: null,
        name: "Community Service Award",
        issuer: "Mental Health America",
        issue_date: "2021-11-20",
        timestamp: "2026-01-08T11:21:40.391354Z",
        u_timestamp: "2026-01-08T11:21:40.391411Z",
        profile_id: 389,
      },
      {
        id: "477ca97e-8045-4bcf-83e3-007d50208a09",
        description: "Honored for innovative trauma therapy approaches",
        upload_img: null,
        name: "Therapist of the Year",
        issuer: "California Psychological Association",
        issue_date: "2024-03-10",
        timestamp: "2026-01-08T11:20:37.842523Z",
        u_timestamp: "2026-01-08T11:20:37.842550Z",
        profile_id: 389,
      },
      {
        id: "5acb32f7-89c8-4b36-ab12-b1a3deb65fc6",
        description: "Recognized for research contributions to CBT efficacy",
        upload_img: null,
        name: "Early Career Excellence Award",
        issuer: "American Psychological Association",
        issue_date: "2019-06-05",
        timestamp: "2026-01-08T11:21:40.403172Z",
        u_timestamp: "2026-01-08T11:21:40.403201Z",
        profile_id: 389,
      },
      {
        id: "6ecd1d0c-a795-44da-b3ce-9310582dcfe1",
        description: "Honored for innovative trauma therapy approaches",
        upload_img: null,
        name: "Therapist of the Year",
        issuer: "California Psychological Association",
        issue_date: "2024-03-10",
        timestamp: "2026-01-08T11:21:40.381944Z",
        u_timestamp: "2026-01-08T11:21:40.381973Z",
        profile_id: 389,
      },
      {
        id: "7da6cb33-06fa-40c3-8b4c-50a48ee44732",
        description: "Mutant Biology - Why humans mutate",
        upload_img:
          "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/Achievement_images/7da6cb33-06fa-40c3-8b4c-50a48ee44732-exp.png",
        name: "PhD in mutant biology",
        issuer: "Cambridge",
        issue_date: "2015-03-27",
        timestamp: "2023-12-03T13:44:15.535120Z",
        u_timestamp: "2023-12-03T13:44:15.535160Z",
        profile_id: 389,
      },
      {
        id: "864d5139-c47f-48f9-aac2-0e0993fdf093",
        description: "Recognized for research contributions to CBT efficacy",
        upload_img: null,
        name: "Early Career Excellence Award",
        issuer: "American Psychological Association",
        issue_date: "2019-06-05",
        timestamp: "2026-01-08T11:20:37.861724Z",
        u_timestamp: "2026-01-08T11:20:37.861751Z",
        profile_id: 389,
      },
      {
        id: "bea46359-48f6-48b4-9175-0c4fbb138b11",
        description:
          "Recognized for outstanding patient outcomes and community impact",
        upload_img: null,
        name: "Excellence in Mental Health Award",
        issuer: "National Alliance on Mental Illness",
        issue_date: "2023-05-15",
        timestamp: "2026-01-08T11:20:37.832276Z",
        u_timestamp: "2026-01-08T11:20:37.832304Z",
        profile_id: 389,
      },
      {
        id: "c2a3b71c-7d4a-4eca-927d-0eb4505eb11b",
        description: "Awarded for pro-bono counseling services during pandemic",
        upload_img: null,
        name: "Community Service Award",
        issuer: "Mental Health America",
        issue_date: "2021-11-20",
        timestamp: "2026-01-08T11:20:37.852149Z",
        u_timestamp: "2026-01-08T11:20:37.852259Z",
        profile_id: 389,
      },
    ],
    volunteer: [
      {
        id: "96afba64-dcc0-4d32-ab61-28263ac7f279",
        description:
          "Working with Amnesty International as a volunteer is a deeply rewarding and eye-opening experience. Over time, you become immersed in the global fight for human rights, gaining firsthand insight into pressing social justice issues. The work often involves researching human rights violations, engaging with diverse communities, and collaborating with passionate activists from around the world.",
        role: "Chief Psychoanalyst",
        cause: "Mental Well being",
        upload_img:
          "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/VolunteerExperience_images/96afba64-dcc0-4d32-ab61-28263ac7f279-exp.png",
        organisation: "Amnesty International",
        start_date: "2024-01-08",
        end_date: "2025-03-05",
        timestamp: "2025-07-05T14:52:59.987754Z",
        u_timestamp: "2025-07-05T14:52:59.987815Z",
        profile_id: 389,
      },
    ],
    skills: [
      {
        id: "24b16284-f212-4cc5-b893-a00ef47c03cd",
        upload_img:
          "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/Skills_images/24b16284-f212-4cc5-b893-a00ef47c03cd-GitVersion.png",
        title: "Git/Version Control",
        description: "Git/Version Control",
        status: true,
        timestamp: "2022-02-19T08:34:47.910427Z",
        u_timestamp: "2022-02-19T08:36:06.351571Z",
      },
      {
        id: "2f97c23b-cd03-41ce-966f-516418f56965",
        upload_img:
          "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/Skills_images/2f97c23b-cd03-41ce-966f-516418f56965-javascript.png",
        title: "Javascript",
        description: "Javascript",
        status: true,
        timestamp: "2022-02-19T08:33:49.379566Z",
        u_timestamp: "2022-02-19T08:33:49.379606Z",
      },
    ],
    interests: [
      {
        id: "9520dff6-3964-4cd2-8350-d2ac19fa5b32",
        title: "Reading",
        description: "",
        upload_img:
          "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/Interest_images/9520dff6-3964-4cd2-8350-d2ac19fa5b32-Reading.jpg",
        status: true,
        timestamp: "2022-02-19T08:59:28.307015Z",
        u_timestamp: "2022-02-19T08:59:28.307057Z",
      },
    ],
    social_links: null,
    dept_code: null,
    publications: [
      {
        id: 1,
        image:
          "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/Publications_images/1-fire-and-blood.jpg",
        title: "House of the Dragon v2",
        description: "Fire & Blood - Stone",
        url: "https://www.westeros.org/",
        publication: "Bantam Press",
        publication_date: "2023-11-08",
        pub_type: "book",
        profile: 389,
      },
      {
        id: 2,
        image:
          "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/Publications_images/None-1670351626_13-kartinkin-net-p-kartinki-momento-more.jpg",
        title: "LOTR v1",
        description: "Lord of the Rings",
        url: "https://gitlab.com",
        publication: "Bantem",
        publication_date: "0203-01-06",
        pub_type: "book",
        profile: 389,
      },
      {
        id: 3,
        image:
          "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/Publications_images/None-jnixqvnrzn791.png",
        title: "Witch Hat",
        description:
          "A witch hat is a style of hat worn by witches in popular culture depictions, characterized by a conical crown and a wide brim.",
        url: "https://github.com",
        publication: "WITCH485848",
        publication_date: "2023-02-12",
        pub_type: "patent",
        profile: 389,
      },
      {
        id: 4,
        image:
          "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/Publications_images/None-61TuTkJmjBL._AC_UF10001000_QL80_.jpg",
        title: "Philosophy of Memento Mori",
        description:
          "Memento mori, in art and spirituality, a symbolic trope or meditative practice that serves as a reminder of mortality and the transitory nature of earthly pleasures. Memento mori is a Latin phrase meaning “remember you must die.” The notion of “remembering death” appears throughout European history, and other cultures have traditions that approach the same concept in unique ways.",
        url: "https://www.britannica.com/topic/memento-mori",
        publication: "MEMO478597",
        publication_date: "2014-11-10",
        pub_type: "paper",
        profile: 389,
      },
      {
        id: 5,
        image:
          "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/Publications_images/None-Bell-Curve.jpeg",
        title: "Dunning-Kruger Effect",
        description:
          "The Dunning-Kruger effect occurs when a person’s lack of knowledge and skill in a certain area causes them to overestimate their own competence. By contrast, this effect also drives those who excel in a given area to think the task is simple for everyone, leading them to underestimate their abilities.",
        url: "https://thedecisionlab.com/biases/dunning-kruger-effect",
        publication: "Decision Lab Inc.",
        publication_date: "2020-08-07",
        pub_type: "case_study",
        profile: 389,
      },
    ],
    project: [
      {
        id: 1,
        image:
          "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/Project_images/None-IBM-Watson.jpg",
        name: "Project Watson",
        description:
          "Watson is a computer system capable of answering questions posed in natural language developed by IBM.",
        start_date: "2021-01-05",
        end_date: "2023-12-10",
        profile: 389,
      },
    ],
    research: [
      {
        id: 1,
        research_type: "industry",
        ongoing: true,
        title: "AGI: Artificial General Intelligence",
        industry_name: "IBM Inc.",
        issue_date: "2020-08-07",
        image:
          "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/Research_images/None-GBHajSGbgAEULbA.jpeg",
        url: "https://www.ibm.com/topics/strong-ai",
        description:
          "Artificial general intelligence (AGI) or general AI, is a theoretical form of AI used to describe a certain mindset of AI development. If researchers are able to develop Strong AI, the machine would require an intelligence equal to humans; it would have a self-aware consciousness that has the ability to solve problems, learn, and plan for the future.",
        profile: 389,
      },
      {
        id: 2,
        research_type: "other",
        ongoing: false,
        title: "Hyperledger Fabric",
        industry_name: "IBM",
        issue_date: "2015-06-09",
        image:
          "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/Research_images/None-hyper.jpeg",
        url: "https://www.ibm.com/topics/hyperledger",
        description:
          "Hyperledger Fabric, an open source project from the Linux Foundation, is the modular blockchain framework and de facto standard for enterprise blockchain platforms.",
        profile: 389,
      },
      {
        id: 3,
        research_type: "industry",
        ongoing: true,
        title: "AGI: Artificial General Intelligence",
        industry_name: "IBM Inc.",
        issue_date: "2020-08-07",
        image:
          "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/Research_images/3-GPT-4.jpg",
        url: "https://www.ibm.com/topics/strong-ai",
        description:
          "Artificial general intelligence (AGI) or general AI, is a theoretical form of AI used to describe a certain mindset of AI development. If researchers are able to develop Strong AI, the machine would require an intelligence equal to humans; it would have a self-aware consciousness that has the ability to solve problems, learn, and plan for the future.",
        profile: 389,
      },
    ],
    trainingandconference: [
      {
        id: 1,
        image:
          "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/TrainingAndConference_images/None-IBM-Watson.jpg",
        title: "Training - Generative  AI",
        organization_name: "IBM Inc.",
        issue_date: "2023-09-30",
        credential_url: "https://research.ibm.com/blog/what-is-generative-A",
        description:
          "Generative AI refers to deep-learning models that can generate high-quality text, images, and other content based on the data they were trained on.",
        profile: 389,
      },
      {
        id: 2,
        image:
          "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/TrainingAndConference_images/None-react-workshop-2.png",
        title: "React Workshop 2.0",
        organization_name: "Meta Inc.",
        issue_date: "2023-06-10",
        credential_url: null,
        description:
          "React is a free and open-source front-end JavaScript library for building user interfaces based on components. It is maintained by Meta and a community of individual developers and companies. React can be used to develop single-page, mobile, or server-rendered applications with frameworks like Next.js",
        profile: 389,
      },
      {
        id: 3,
        image:
          "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/TrainingAndConference_images/None-node-logo_bc9pmTiyKR0WNPka2w3e0Q.png",
        title: "Node.JS Workshop",
        organization_name: "OpenJS Foundation",
        issue_date: "2022-06-10",
        credential_url: "https://www.netguru.com/glossary/node-js",
        description:
          "Node.js is an open source, cross-platform runtime environment and library that is used for running web applications outside the client’s browser.",
        profile: 389,
      },
      {
        id: 4,
        image:
          "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/TrainingAndConference_images/None-GBHajSGbgAEULbA.jpeg",
        title: "AGI: Artificial general intelligence",
        organization_name: null,
        issue_date: "2020-03-05",
        credential_url: null,
        description:
          "Artificial General Intelligence (AGI) or general AI, is a theoretical form of AI used to describe a certain mindset of AI development. If researchers are able to develop Strong AI, the machine would require an intelligence equal to humans; it would have a self-aware consciousness that has the ability to solve problems, learn, and plan for the future.",
        profile: 389,
      },
      {
        id: 5,
        image:
          "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/TrainingAndConference_images/5-black-flowers-1330260.png",
        title: "Python Workshop",
        organization_name: "Python Software Foundation",
        issue_date: "2022-02-11",
        credential_url: "https://docs.python.org/3/",
        description:
          "Python is an interpreted, object-oriented, high-level programming language with dynamic semantics developed by Guido van Rossum.",
        profile: 389,
      },
      {
        id: 6,
        image:
          "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/TrainingAndConference_images/None-RedHat_Logo_Whitebg1200x1200.jpg",
        title: "Red Hat Enterprise Linux",
        organization_name: "Red Hat Inc.",
        issue_date: "2021-09-26",
        credential_url: "https://www.redhat.com/en/topics/linux",
        description:
          "Red Hat Enterprise Linux is a distribution of the Linux operating system. The Red Hat organization develops it for the business or the enterprise market. It is also commonly abbreviated as RHEL.",
        profile: 389,
      },
      {
        id: 7,
        image:
          "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/TrainingAndConference_images/None-GBHajSGbgAEULbA.jpeg",
        title: "Django",
        organization_name: "IBM",
        issue_date: "2023-12-22",
        credential_url: "https://gitlab.com",
        description: "Something",
        profile: 389,
      },
    ],
    dept_id: "848bb461-0097-46af-95d5-3de55601fbec",
    is_enterprise_admin: false,
    user_category: "TEACHER",
    open_to_work: {
      id: "dcea3e7b-4790-4bf1-b323-1fc895cdbcbb",
      job_title: ["Researcher"],
      preferred_work_location: ["ONSITE"],
      start_availability: ["IMMEDIATELY"],
      employment_types: ["FULLTIME"],
      visibility: true,
      profile_id: 389,
    },
    expertise: [
      {
        id: 1,
        name: "Anxiety & Depression Treatment",
        timestamp: "2026-01-08T11:20:09.442922Z",
        u_timestamp: "2026-01-08T11:20:09.442959Z",
        profile: 389,
      },
      {
        id: 2,
        name: "Anxiety & Depression Treatment",
        timestamp: "2026-01-08T11:20:37.764482Z",
        u_timestamp: "2026-01-08T11:20:37.764518Z",
        profile: 389,
      },
      {
        id: 3,
        name: "Trauma Recovery",
        timestamp: "2026-01-08T11:20:37.774755Z",
        u_timestamp: "2026-01-08T11:20:37.774790Z",
        profile: 389,
      },
      {
        id: 4,
        name: "Anxiety & Depression Treatment",
        timestamp: "2026-01-08T11:21:40.340839Z",
        u_timestamp: "2026-01-08T11:21:40.340876Z",
        profile: 389,
      },
      {
        id: 5,
        name: "Trauma Recovery",
        timestamp: "2026-01-08T11:21:40.350806Z",
        u_timestamp: "2026-01-08T11:21:40.350844Z",
        profile: 389,
      },
    ],
    specialization: [
      {
        id: 1,
        name: "Cognitive Behavioral Therapy",
        timestamp: "2026-01-08T11:19:09.712561Z",
        u_timestamp: "2026-01-08T11:19:09.712599Z",
        profile: 389,
      },
      {
        id: 2,
        name: "Couples Counseling",
        timestamp: "2026-01-08T11:19:09.722089Z",
        u_timestamp: "2026-01-08T11:19:09.722126Z",
        profile: 389,
      },
      {
        id: 3,
        name: "Cognitive Behavioral Therapy",
        timestamp: "2026-01-08T11:21:40.299083Z",
        u_timestamp: "2026-01-08T11:21:40.299122Z",
        profile: 389,
      },
      {
        id: 4,
        name: "Couples Counseling",
        timestamp: "2026-01-08T11:21:40.310748Z",
        u_timestamp: "2026-01-08T11:21:40.310786Z",
        profile: 389,
      },
    ],
    verified_documents: [],
    professional_memberships: [
      {
        id: "8507dcf4-c470-4faf-b247-f9f48986f172",
        organisation: "American Psychological Association",
        description: "Active member of Division 12 (Clinical Psychology)",
        start_date: "2016-01-01",
        end_date: "2026-01-01",
        role: "Clinical Psychologist Member",
        timestamp: "2026-01-08T11:20:37.872483Z",
        u_timestamp: "2026-01-08T11:20:37.872512Z",
        profile_id: 389,
      },
      {
        id: "9eeab2f0-ed08-4870-99e4-1046771a694b",
        organisation: "American Psychological Association",
        description: "Active member of Division 12 (Clinical Psychology)",
        start_date: "2016-01-01",
        end_date: "2026-01-01",
        role: "Clinical Psychologist Member",
        timestamp: "2026-01-08T11:21:40.412907Z",
        u_timestamp: "2026-01-08T11:21:40.412937Z",
        profile_id: 389,
      },
    ],
    name: "Prof. charles xavier",
    professional_title: "",
    experience_years: 8,
    designation: "Founder of Xavier's School for Gifted Youngsters",
    location: "NYC",
    organisation: "",
    gender: "",
    views: 0,
    is_creator: true,
    profile_pic:
      "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/dpImages/389-prof-x-p8p8em.jpg",
    cover_pic:
      "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/coverImages/389-x-2.png",
    signature:
      "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/Profile_images/389-signature.png",
    bookmarks: "",
    profile_link: "uLuMmmKY",
    search_appearance: 0,
    tags: "CBT, Mindfulness, Trauma Therapy",
    language_known: "English, Hindi",
    language_code: "en, hi, it",
    about:
      "Compassionate licensed therapist with 8 years of experience helping individuals and couples navigate emotional challenges and build resilience",
    address: "New York",
    state: "",
    state_code: "",
    country: "undefined",
    country_code: "undefined",
    dob: "1975-03-06",
    short_bio: "1",
    trainingAndconference_visibility: true,
    research_visibility: true,
    project_visibility: true,
    publications_visibility: true,
    timestamp: "2023-09-20T08:19:16.646476Z",
    u_timestamp: "2026-02-06T05:10:31.311862Z",
    connections: [391, 392, 399, 410],
  },
  name: "Therapy 101",
  category: "Meditaiton",
  duration: 60,
  description: "CBT session to get to know yourself and your habits",
  conversation_type_amount: {
    call: 700,
  },
  objective: "Learning CBT. See what you can use it for.",
  setting_config: {
    level: "Beginner",
    language: "English",
  },
  is_live: true,
  max_booking_per_day: 15,
  attachments:
    "https://www.hpft.nhs.uk/media/1655/wellbeing-team-cbt-workshop-booklet-2016.pdf",
  is_active: true,
  timestamp: "2026-02-05T11:49:42.477091Z",
  utimestamp: "2026-02-05T11:49:42.477124Z",
};
